import { Loading, PlantCard } from '@components'
import { FEATURE, ROUTES } from '@constants'
import { useGetFeatures, useGetPlantList, useNavigation } from '@hooks'
import React, { useState } from 'react'

import { Style } from './style'
import { hasFeature } from '@helpers/dashboard'

const PlantList = () => {
  const { goToPlantDetail } = useNavigation()
  const { isLoading: isPlantListLoading, data: plantList } = useGetPlantList()
  const { isLoading: isFeatureLoading, data: featureList } = useGetFeatures()
  const isEnabled = hasFeature(featureList, FEATURE.SUMMARY_DASHBOARD)
  const isLoading = isPlantListLoading || isFeatureLoading
  const isAllowUpdateStatus =
    !isLoading && hasFeature(featureList, FEATURE.DASHBOARD_MANAGEMENT)
  const goToSummary = () => window.open(`${window.location.origin}${ROUTES.SUMMARY}`, '_blank')

  return (
    <Style>
      {isLoading && <Loading />}
      {plantList && (
        <React.Fragment>
          <div className='head'>Plant Managements ( {plantList.length} )</div>
          <div className='list'>
            {isEnabled && (
              <PlantCard
                plant={{ name: 'Summary', description: 'All Plant' }}
                isAllowUpdateStatus={isAllowUpdateStatus}
                index={0}
                goToPlantDetail={goToSummary}
              />
            )}
            {plantList.map((plant, index) => (
              <PlantCard
                key={plant.plant_id}
                plant={plant}
                isAllowUpdateStatus={isAllowUpdateStatus}
                index={index + 1}
                goToPlantDetail={goToPlantDetail}
              />
            ))}
          </div>
        </React.Fragment>
      )}
    </Style>
  )
}

export default PlantList
